import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "KickLoom — AI Football Predictions";
const DEFAULT_DESCRIPTION =
    "Daily 2, 5 and 10-game accumulator picks powered by AI. Live odds, confidence scores, and real-time fixtures.";

export default function Seo({
    title,
    description = DEFAULT_DESCRIPTION,
    path = "",
    jsonLd,
    noIndex = false,
}) {
    const fullTitle = title ? `${title} — KickLoom` : DEFAULT_TITLE;
    const canonical = `https://kickloom.com${path}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            {noIndex && <meta name="robots" content="noindex,nofollow" />}
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
